module.exports = __webpack_public_path__ + "static/media/ellie_huang.7002572e.png";